import { render, staticRenderFns } from "./Package-Items.vue?vue&type=template&id=9fe462f4&"
import script from "./Package-Items.vue?vue&type=script&lang=js&"
export * from "./Package-Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports